import { useState } from "react";
import { PaginationArrow } from "../../../resources/assetsManager";
import "./pagination.css";
import { usePagination } from "./usePagination";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    totalPages,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const [searchWithPage, setSearchWithPage] = useState(currentPage);

  if (currentPage === 0 || paginationRange?.length < 2) {
    return null;
  }

  const onNext = () => {
    if (currentPage !== lastPage) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage >= 2) {
      onPageChange(currentPage - 1);
    }
  };

  const onSearchPage = () => {
    if (searchWithPage <= totalPages && searchWithPage >= 1) {
      onPageChange(searchWithPage);
    } else setSearchWithPage("");
  };

  let lastPage = paginationRange[paginationRange?.length - 1];

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#FFFFFF",
        padding: 20,
        boxSizing: "border-box",
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
        color: "black",
        position: "relative",
        minHeight: 70,
      }}
    >
      {currentPage !== 1 ? (
        <div
          style={{
            border: "1px solid #3783FB",
            width: 30,
            height: 30,
            borderRadius: 5,
            marginLeft: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            left: 50,
            position: "absolute",
          }}
          onClick={onPrevious}
        >
          <img
            src={PaginationArrow}
            style={{ transform: "rotate(180deg)" }}
            alt="LeftArrow"
          />
        </div>
      ) : (
        <div />
      )}

      <div
        style={{
          display: "flex",
          alignItems: "center",
          left: "45%",
          position: "absolute",
        }}
      >
        <p
          style={{
            fontSize: 12,
            fontWeight: "bold",
            alignItems: "center",
            color: "black",
            marginRight: 20,
          }}
        >
          {currentPage} {totalPages ? "/ " + totalPages : ""}
        </p>

        <div
          style={{
            border: "1px solid black",
            width: 30,
            height: 30,
            borderRadius: 5,
            marginLeft: 10,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "black",
            fontSize: 12,
            fontWeight: "500",
          }}
          className="roboto"
        >
          {currentPage}
          {/* <input
            value={searchWithPage}
            onChange={(e) => setSearchWithPage(e.target.value)}
            // onKeyDown={() => onSearchPage()}
            style={{
              border: "0px solid black",
              width: 20,
              outline: "none",
            }}
          /> */}
        </div>
      </div>

      {currentPage !== totalPages ? (
        <div
          style={{
            border: "1px solid #3783FB",
            width: 30,
            height: 30,
            borderRadius: 5,
            marginLeft: 10,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            right: 50,
            position: "absolute",
          }}
          onClick={onNext}
        >
          <img src={PaginationArrow} alt="RightArrow" />
        </div>
      ) : (
        <div />
      )}
    </div>
  );
};

export default Pagination;
